import { getAppInfo } from '@/utils/bridge';
import { routeToLoginAndUpdateStatus } from '@/utils/routes';
import { Toast } from 'antd-mobile';
import fetch from 'dva/fetch';
import qs from 'qs';

const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  413: '请求内容过大',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。',
};

const checkStatus = response => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const errortext = codeMessage[response.status] || response.statusText;
  console.error(`请求错误 ${response.status}: ${response.url}`);

  const error = new Error(errortext);
  error.name = response.status;
  error.response = response;
  throw error;
};

const offlinePromise = () =>
  new Promise((resolve, reject) => {
    if (!navigator.onLine) {
      console.log('断网了233');
      reject(new Error('offline'));
    } else {
      resolve('online');
    }
  });

// const fetchTimeout = (maxWaiting = 10 * 1000, message = '请求超时') => {
//   return new Promise((resolve, reject) => {
//     setTimeout(() => {
//       Toast.info(message);
//       reject(message);
//     }, maxWaiting);
//   });
// };

function requestPromise(url, option) {
  const defaultOptions = {
    credentials: 'include',
    // selfCase 自定义错误处理
    selfCase: false,
  };

  const newOptions = { ...defaultOptions, ...option };
  newOptions.headers = {
    Accept: 'application/json',
    ...newOptions.headers,
  };
  if (
    newOptions.method === 'POST' ||
    newOptions.method === 'PUT' ||
    newOptions.method === 'DELETE'
  ) {
    switch (newOptions.dataType) {
      case 'json':
        newOptions.body = JSON.stringify(newOptions.body);
        break;
      case 'formData':
        const reqBody = new FormData();
        Object.keys(newOptions.body).forEach(key => {
          reqBody.append(key, newOptions.body[key]);
        });
        // 不用设置请求头，因为无法得知boundary定义方式
        newOptions.body = reqBody;
        break;
      case 'form':
        newOptions.body = qs.stringify(newOptions.body);
        newOptions.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        break;
      default:
        newOptions.body = JSON.stringify(newOptions.body);
        break;
    }
  }
  return fetch(url, newOptions)
    .then(checkStatus)
    .then(response => {
      if (newOptions.method === 'DELETE' || response.status === 204) {
        return response.text();
      }
      if (newOptions.arrayBuffer) {
        return response.text().then(resString => {
          const noNumKeyRes = resString.replace(/(\d+):/g, '"$1":');
          const decoderJSON = JSON.parse(noNumKeyRes);
          console.log('decoderJSON: ', decoderJSON);
          return {
            code: decoderJSON.code,
            message: decoderJSON.data,
          };
        });
      }
      return response.json();
    })
    .then(res => {
      console.log(url);
      console.log('requestPromise.res: ', res);
      // 取消loading
      if (newOptions.hideLoading) Toast.hide();
      // 兼容账号体系的公共字段
      const realRes = {
        iRet: res.errCode ?? res.iRet,
        data: res.data || {},
        sMsg: res.errMsg || res.sMsg,
      };
      switch (realRes.iRet) {
        case 0:
          return realRes;
        // 登陆超时
        // 被踢
        case -11004:
        case -501:
        case -11014:
        case -503:
          routeToLoginAndUpdateStatus(1);
          break;
        default:
          if (newOptions.selfCase) {
            return realRes;
          }
          Toast.info(realRes.sMsg || '请求出错');
      }
    })
    .catch(e => {
      if (e?.message.toLowerCase().indexOf('failed') !== -1) {
        Toast.info('网络异常，请稍后再试');
      } else {
        Toast.info('请求出错');
      }
      const status = e.name;
      // TODO
      // if (status > 400) {
      //   router.push('/exception/404');
      // }
    });
}

export default function request(url, option) {
  return offlinePromise()
    .then(() => {
      return requestPromise(url, option);
    })
    .catch(e => {
      Toast.info('网络异常，请稍后再试');
      return null;
    });
}

export async function postRequest(
  url,
  data = {},
  requestOptions = { dataType: 'json', hideLoading: true }
) {
  let userState = window.g_app._store.getState().user;
  if (!userState?.version) {
    const appInfoRes = await getAppInfo();
    if (appInfoRes?.code === 0) {
      userState = appInfoRes.data;
    }
  }

  let commonParams = { origin: userState?.origin || '1' };
  // 直接调用外控的接口需要额外设置一些公共参数
  if (url.includes('/api/consolepro') || url.includes('/v1/devices/')) {
    // orgin 终端类型：1：WEB，2：PLUGIN，3：SERVER
    commonParams.origin = '1';
  } else {
    commonParams.appversion = userState?.version || '5.0.0';
  }
  /* let cookie = await refreshCookie();
  console.log('postRequest.cookie >> ', cookie); */

  return request(`${url}`, {
    method: 'POST',
    body: {
      ...commonParams,
      ...data,
    },
    ...requestOptions,
  });
}

export async function getRequest(url, dataType = 'json') {
  return request(`${url}`, {
    method: 'GET',
    dataType: dataType,
  });
}
